import React from 'react';
import { useNavigate } from 'react-router-dom';
import Container from '../../components/container';
import BrandLogo from '../../components/brand/BrandLogo';

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <Container title="Page not found">
      <div style={{ textAlign: 'center' }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 16 }}>
          <BrandLogo variant="banner" tone="onLight" />
        </div>
        <h1 style={{ fontSize: 72, color: '#d9534f', marginBottom: 16 }}>404</h1>
        <h2 style={{ color: '#222', marginBottom: 24 }}>Page Not Found</h2>
        <p style={{ color: '#888', marginBottom: 32 }}>
          Sorry, the page you are looking for does not exist.
        </p>
        <button
          onClick={() => navigate('/')}
          style={{
            padding: '10px 20px',
            fontSize: 14,
            background: '#dc2626',
            color: '#fff',
            border: 'none',
            borderRadius: 8,
            cursor: 'pointer',
            fontWeight: 600,
          }}
        >
          Go Home
        </button>
      </div>
    </Container>
  );
};

export default NotFound;
